import { render, staticRenderFns } from "./page-statistics.vue?vue&type=template&id=b976fcea"
import script from "./page-statistics.vue?vue&type=script&lang=ts"
export * from "./page-statistics.vue?vue&type=script&lang=ts"
import style0 from "./page-statistics.vue?vue&type=style&index=0&id=b976fcea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports